import { useState, useEffect } from "react";

export default (value: any, timeout = 2000) => {
  const [state, setState] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => setState(value), timeout);
    return () => clearTimeout(handler);
  }, [value]);

  return state;
};
